const adjustReco = () => {
  const recoPanel = document.querySelector('.reco-panel');
  const nextItem = document.querySelector('.item-next-prev');
  if (recoPanel) {
    const mediaq = window.matchMedia('(max-width: 850px)');
    if (scrollY < 295) {
      if (mediaq.matches) {
        recoPanel.style.top = `${365 - scrollY}px`;
      } else {
        recoPanel.style.top = `${385 - scrollY}px`;
      }
    } else {
      recoPanel.style.top = '85px';
    }
  }

  if (nextItem) {
    if (scrollY > 500) {
      nextItem.style.display = 'none';
    } else {
      nextItem.style.display = 'block';
    }
  }
};

module.exports = { adjustReco };



// WEBPACK FOOTER //
// ./scriptPartials/adjustReco.js